import React from "react";
import useSelect from "../hooks/useSelect";
import {
  Select as SSelect,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "components/ui/select";

// Props: { options, initialValue, onOptionChange, colorMap }
function Select({ options, initialValue, onOptionChange, colorMap }) {
  const { selectedOption, handleOptionChange } = useSelect(initialValue, onOptionChange);

  // Radix can't use "" as a value; use "all" and map back to "" for your state/backend
  const mapOut = (v) => (v === "" || v == null ? "all" : String(v));
  const mapIn = (v) => (v === "all" ? "" : v);

  // Give your hook an event-like object so it keeps working
  const handleRadixChange = (val) =>
    handleOptionChange({ target: { value: mapIn(val) } });

  const currentUIValue = mapOut(selectedOption);
  const bg = colorMap?.[mapIn(currentUIValue)] || "transparent";

  return (
    <div className="w-full">
      <SSelect value={currentUIValue} onValueChange={handleRadixChange}>
        <SelectTrigger className="w-full" style={{ backgroundColor: bg }} aria-label="בחר סטטוס">
          <SelectValue placeholder="בחר" />
        </SelectTrigger>
        <SelectContent position="popper" className="max-h-64">
          {/* Ensure no empty-string values */}
          {options.map((opt) => {
            const v = mapOut(opt.value);
            return (
              <SelectItem key={v} value={v}>
                {opt.label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </SSelect>
    </div>
  );
}

export default Select;
